import { Directive, ElementRef, HostListener, Input } from '@angular/core'
import { CustomCheckboxComponent } from 'src/components/custom-checkbox.component'

@Directive({
  selector: '[pass-event-to]',
  exportAs: 'pet'
})
export class PassEventToDirective {

  @Input('pass-event-to') passEventTo!: any
  @Input('listen-to') listenTo: string = 'click'

  constructor(private el: ElementRef) {}

  @HostListener('click', ['$event']) onClick(event: MouseEvent) {
    this.passEventTo.click()
    event.stopPropagation()
    event.preventDefault()
  }

}
